import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllEsicCount = createAsyncThunk(
    'report/fetchAllEsicCount',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/esic/count`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Esic Report');
        }
    }
);
export const fetchAllEsicMonthlyCount = createAsyncThunk(
    'report/fetchAllEsicMonthlyCount',
    async (year : any, { rejectWithValue }) => {
        try {
            console.log("get it1")
            const response = await employeeServiceApiInstance.get(`/report/esic/monthly/count`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Esic Report');
        }
    }
);
export const fetchAllEsicDetails = createAsyncThunk(
    'report/fetchAllEsicDetails',
    async ( year : any, { rejectWithValue }) => {
        try {
            console.log("get it 2")
            const response = await employeeServiceApiInstance.get(`/report/esic/details/all/esicreport/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Esic Report');
        }
    }
);